var _style, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSimpleDore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 280 195",
    style: {
      enableBackground: "new 0 0 280 195"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FAF1E4;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.2,126.9c0-30.7,19.6-34.6,86.6-98.8c-72.1,52.5-81.5,51.1-86.6,49.7C185,74.9,177,28.1,177,28.1v55.3v77.5 l68.4,34.1C245.4,195,193.2,156.1,193.2,126.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.6,6.2c-7.7,2.8-12.5,7.4-14.5,13.3c-4,11.1,3.4,24.4,3.7,24.4l61.3,107V27.5c0-0.3,0-15.3-8.8-23 c-3.7-3.1-8.2-4.5-13.9-4.5c-1.7,0-3.7,0.3-5.7,0.6l-9.9,2.6L110.6,6.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.2,110.7L3,122.3l-2.6,10.2c-1.1,8.2,0.3,14.8,4.3,19.3c6.8,7.9,19,8.8,22.7,8.8h0.3h122.9l-106.7-61 c0,0-8.2-4.8-17.3-4.8c-2.3,0-4.8,0.3-7.1,1.1C13.8,97.9,9.3,102.8,6.2,110.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.1,55.3C34,61.5,32,68.1,33.1,74c2.3,11.6,15.3,19,15.3,19.3L154.9,155L93.3,48.3C93.3,48,85.6,35,74,33 c-0.9-0.3-2-0.3-3.1-0.3c-5.1,0-10.2,2.3-15.6,6.5l-7.4,7.4L39.1,55.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.9,106.2c-6.2-8.2-15.9-13.3-27-13.3c-18.7,0-33.8,15.3-33.8,34.1c0,18.7,15,33.8,33.8,33.8h27h7.1V127 C276.9,119.2,274.4,112.1,269.9,106.2z M257.1,121.2h-1.7h-6.5c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.5,8.2-8.5c2.6,0,5.1,1.1,6.5,3.4 c1.1,1.4,1.7,3.1,1.7,5.1V121.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimpleDore);
export default __webpack_public_path__ + "static/media/logo-simple-dore.90a121d5456c4cc4279d287ea1f950cb.svg";
export { ForwardRef as ReactComponent };